import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Inject,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    Output
} from '@angular/core';
import {PagingApiService} from '@abstract/paging-api.service';
import {ListItemsComponent} from '@abstract/list-items/list-items.component';

@Component({
    selector: 'app-card-select-modal',
    templateUrl: 'card-select-modal.component.html',
    styleUrls: ['card-select-modal.component.scss'],
})

export class CardSelectModalComponent extends ListItemsComponent implements OnInit, OnChanges, OnDestroy, AfterViewInit {
    /**
     * id уже выбранных карточек оборудования
     */
    @Input() defaultCardIds: number[] = [];

    /**
     * Имя кнопки
     */
    @Input() buttonName = 'Выбрать оборудование со склада';

    @Input() modalTitle = 'Оборудование на объекте';

    @Input() showFilters = false;

    @Output() cardIdsSelected = new EventEmitter<number[]>();

    public cardIds: number[] = [];

    constructor(
        @Inject('EquipmentCardSelectApiService') service: PagingApiService,
        private cd: ChangeDetectorRef,
    ) {
        super(service);
    }

    ngOnInit() {
        super.ngOnInit();
        this.init();
    }

    ngAfterViewInit(): void {
        this.cd.detach();
    }

    ngOnChanges() {
        this.cardIds = [...this.defaultCardIds];
    }

    onModalShow() {
        this.cd.reattach();
        this.service.updateItems();
    }

    onModalClose() {
        this.cardIds = [...this.defaultCardIds];
        this.service.resetParams();
        this.service.items$.next([]);
        this.cd.detach();
    }

    /**
     * Добавить карточку как выбранную
     * @param id
     */
    addCardToChose(id: number) {
        if (this.cardIds.includes(id)) {
            return;
        }

        this.cardIds.push(id);
    }

    /**
     * Удалить карточку из выбора
     * @param id
     */
    removeCardFromChose(id: number) {
        if (!this.cardIds.includes(id)) {
            return;
        }

        this.cardIds.splice(this.cardIds.indexOf(id), 1);
    }

    toggleCardChose(id: number) {
        if (this.cardIds.includes(id)) {
            this.removeCardFromChose(id);
        } else {
            this.addCardToChose(id);
        }
    }

    /**
     * Выбрать выделенное оборудование (передать событие во вне, что оборудование выбрано)
     */
    select() {
        this.cardIdsSelected.emit(this.cardIds);
    }

    /**
     * Очистить все выбранное оборудование
     */
    clear() {
        this.cardIds = [];
    }

    /**
     * Добавить к выбранному все видимое на странице оборудование
     */
    addVisibleCards() {
        const items = this.service.items$.getValue();
        const ids = items.map(item => item.id).filter(id => !this.cardIds.includes(id));
        this.cardIds.push(...ids);
    }

    init() {
        this.service.resetParams();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
    }
}
